import React from "react";

import { useDossier } from "@app/contexts/DossierContext";
import DossierPDLInputs from "@app/components/2_widgets/dossiers/DossierPDLInputs";
import DossierAddPDL from "@app/components/2_widgets/dossiers/DossierAddPDL";

export default function SectionPDL({ activateSaved }) {
    const dossier = useDossier();

    function displayPDL(structureData, index) {
        return (
            <DossierPDLInputs key={index} structureData={structureData}/>
        )        
    }

    return (
        <div>
            <div className="gray-line mb-4 mt-2"></div>
            <div className="row mb-4">
                <div className="col-6">
                    <strong>Points de livraison (PDL)</strong>
                </div>
                <div className="col-6">
                    <DossierAddPDL />
                </div>
            </div>            

            {dossier.structure_datas?.map(displayPDL)}            
        </div>
    )
}